import ResourceSvc from '@/services/resource.svc.js';
import { Table, TableColumn } from 'element-ui';

const resourceService = new ResourceSvc();

export default {
    name: 'AdminClubAdminsSection',

    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },

    props: {
        clubAdmins: {
            type: Array,
            required: true
        },
        clubAdminIds: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            newAdminQuery: '',
            lookupLoading: false,
            lookupError: ''
        };
    },

    methods: {
        emitUpdatedLists(admins, ids) {
            this.$emit('update:clubAdmins', admins);
            this.$emit('update:clubAdminIds', ids);
        },

        parseAdminFromResponse(data) {
            return {
                id: data['Id'],
                tiNumber: data['TI Number'],
                fullName: ((data['First Name'] || '') + ' ' + (data['Last Name'] || '')).trim(),
                email: data['Email'] || ''
            };
        },

        async lookupAndAdd() {
            const query = (this.newAdminQuery || '').trim();
            if (!query) {
                this.lookupError = 'Please enter a TI Number or email address';
                return;
            }

            this.lookupLoading = true;
            this.lookupError = '';

            try {
                const response = await resourceService.getMemberByLoginOrTiID(query);
                if (!response || !response.body || !response.body.isSuccess || !response.body.outputData) {
                    this.lookupError = 'User not found';
                    return;
                }

                const admin = this.parseAdminFromResponse(response.body.outputData);

                if (this.clubAdminIds.some(id => id === admin.id)) {
                    this.lookupError = admin.fullName + ' is already a club administrator';
                    return;
                }

                this.emitUpdatedLists(
                    [...this.clubAdmins, admin],
                    [...this.clubAdminIds, admin.id]
                );
                this.newAdminQuery = '';
            } catch (e) {
                this.lookupError = 'Error looking up user';
            } finally {
                this.lookupLoading = false;
            }
        },

        removeAdmin(index) {
            const admin = this.clubAdmins[index];
            if (!admin) return;
            const admins = this.clubAdmins.filter(a => a.id !== admin.id);
            const ids = admins.map(a => a.id);
            this.emitUpdatedLists(admins, ids);
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/club/club-detail/sections/admin-club-admins-section/admin-club-admins-section.js